import { useQuery } from "@tanstack/react-query";
import { fetchJson } from "@/lib/queryClient";
import { TOLERANCIA_DIAS_COLHEITA, normalizarToleranciaDias } from "@shared/tolerancia";

type Parametro = { chave: string; valor: string };

/**
 * A tolerância de colheita configurada, **em número**, num lugar só.
 *
 * Existe porque cada tela lia o parâmetro do seu jeito e três delas nem liam:
 * `ciclos.tsx`, `dashboard.tsx` e `analise-ciclo.tsx` tinham `+ 15` cravado no
 * código para decidir "atrasado", enquanto a Boa Vista está em **35** desde o
 * estudo de calibração — um ciclo era pintado de atrasado 20 dias cedo demais.
 *
 * 🔴 A conversão acontece AQUI, na origem. `parametros.valor` é `text` no banco:
 * quem devolvesse a string crua faria todo `+ tolerancia` virar concatenação
 * ("2026-10-07" + "35"). Devolver number fecha a porta.
 */
export function useToleranciaDias(): number {
  const { data } = useQuery<Parametro[]>({
    queryKey: ["/api/parametros"],
    queryFn: () => fetchJson<Parametro[]>("/api/parametros"),
  });

  return normalizarToleranciaDias(
    data?.find(p => p.chave === TOLERANCIA_DIAS_COLHEITA)?.valor,
  );
}
